export const FOOTER = 'footer';
export const BODY = 'body';
